import React, { useState } from "react";
import { toast } from "react-toastify";
import { changePwd } from "../api/users.api.js";

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  userName?: string; // Opcional, para mostrar a quién le cambias la pass
}

const ChangePasswordModal = ({ isOpen, onClose, userId, userName }: ChangePasswordModalProps) => {
  const [newPwd, setNewPwd] = useState("");
  const [newPwdConfirm, setNewPwdConfirm] = useState("");
  const [isSendingPwd, setIsSendingPwd] = useState(false);

  if (!isOpen) return null;

  const handleConfirmPasswordChange = async () => {
    if (!newPwd || newPwd.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres.");
      return;
    }

    if (newPwd !== newPwdConfirm) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }

    try {
      setIsSendingPwd(true);
      await changePwd(userId, newPwd);
      toast.success("Contraseña cambiada correctamente.");
      setNewPwd("");
      setNewPwdConfirm("");
      onClose();
    } catch (error) {
      console.error(error);
      toast.error("No se pudo cambiar la contraseña.");
    } finally {
      setIsSendingPwd(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[70]"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-lg w-full max-w-lg p-6 shadow-lg" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg md:text-xl font-bold mb-1 text-gray-800">
          🔐 Cambiar contraseña
        </h2>
        {userName && <p className="text-sm text-gray-500 mb-4">Usuario: {userName}</p>}

        <div className="space-y-4">
          <div>
            <label className="block text-sm text-gray-700 mb-1.5">Nueva contraseña*</label>
            <input
              type="password"
              className="w-full text-base border rounded-lg px-4 py-3 md:py-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              style={{ fontSize: '16px' }}
              value={newPwd}
              onChange={(e) => setNewPwd(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1.5">Confirmar contraseña*</label>
            <input
              type="password"
              className="w-full text-base border rounded-lg px-4 py-3 md:py-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              style={{ fontSize: '16px' }}
              value={newPwdConfirm}
              onChange={(e) => setNewPwdConfirm(e.target.value)}
            />
            {newPwd && newPwdConfirm && newPwd !== newPwdConfirm && (
              <p className="text-red-500 text-sm mt-1">⚠️ Las contraseñas no coinciden.</p>
            )}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-5 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400"
            disabled={isSendingPwd}
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmPasswordChange}
            className="w-full sm:w-auto px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-blue-300"
            disabled={isSendingPwd}
          >
            {isSendingPwd ? "Guardando..." : "Aceptar"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;